import { ModuleWithProviders, NgModule } from '@angular/core';
import { CoreModule } from '@myia/ngx-core';
import { ContainerSizesDirective } from './directives/containerSizes.directive';
import { DynamicTemplateComponent } from './components/dynamicTemplate.component';
import { SvgIconDataComponent } from './components/svgIconData.component';
import { TemplateHasCountDownPipePipe } from './components/templateHasCountDownPipe';
import { TransformBackgroundTemplatePipe } from './components/transformBackgroundTemplatePipe';
import { AutoFocusDirective } from './directives/autoFocusDirective';
import { DetectBrowserDirective } from './directives/detectBrowserDirective';
import { FormFieldDirective } from './directives/formFieldDirective';
import { HideScrollbarDirective } from './directives/hideScrollbarDirective';
import { HighlightInvalidFieldsDirective } from './directives/highlightInvalidFieldsDirective';
import { ImageLoadedDirective } from './directives/imageLoaderDirective';
import { TransitionGroupComponent, TransitionGroupItemDirective } from './directives/itemTransitionDirectives';
import { MousePanDirective } from './directives/mousePanDirective';
import { NumberOnlyDirective } from './directives/numberOnlyDirective';
import { MouseWheelDirective } from './directives/mouseWheelDirective';
import { ProgressIndicatorCircleComponent } from './components/progressIndicatorCircle';
import { ProgressIndicatorBarComponent } from './components/progressIndicatorBar';
import { SvgIconComponent } from './components/svgIcon.component';
import { OrderByPipe } from './pipes/orderByPipe';
import { RouterActivatedDirective } from './directives/routerActivatedDirective';
import { SanitizeHtmlPipe } from './pipes/sanitizeHtmlPipe';
import { TrackMouseFocusDirective } from './directives/trackMouseFocusDirective';
import { KeysPipe } from './pipes/keysPipe';
import { LetDirective } from './directives/letDirective';
import { FalsyPipe } from './pipes/falsyPipe';
import { MutableArrayPipe } from './pipes/mutableArrayPipe';

@NgModule({
  imports: [
    CoreModule,
  ],
  declarations: [
    AutoFocusDirective,
    ContainerSizesDirective,
    DetectBrowserDirective,
    DynamicTemplateComponent,
    FalsyPipe,
    FormFieldDirective,
    HideScrollbarDirective,
    HighlightInvalidFieldsDirective,
    ImageLoadedDirective,
    KeysPipe,
    LetDirective,
    MousePanDirective,
    MouseWheelDirective,
    MutableArrayPipe,
    NumberOnlyDirective,
    OrderByPipe,
    ProgressIndicatorBarComponent,
    ProgressIndicatorCircleComponent,
    RouterActivatedDirective,
    SanitizeHtmlPipe,
    SvgIconComponent,
    SvgIconDataComponent,
    TemplateHasCountDownPipePipe,
    TrackMouseFocusDirective,
    TransformBackgroundTemplatePipe,
    TransitionGroupComponent,
    TransitionGroupItemDirective,
  ],
  exports: [
    AutoFocusDirective,
    ContainerSizesDirective,
    DetectBrowserDirective,
    DynamicTemplateComponent,
    FalsyPipe,
    FormFieldDirective,
    HideScrollbarDirective,
    HighlightInvalidFieldsDirective,
    ImageLoadedDirective,
    KeysPipe,
    LetDirective,
    MousePanDirective,
    MouseWheelDirective,
    MutableArrayPipe,
    NumberOnlyDirective,
    ProgressIndicatorBarComponent,
    ProgressIndicatorCircleComponent,
    OrderByPipe,
    RouterActivatedDirective,
    SanitizeHtmlPipe,
    SvgIconComponent,
    SvgIconDataComponent,
    TemplateHasCountDownPipePipe,
    TrackMouseFocusDirective,
    TransformBackgroundTemplatePipe,
    TransitionGroupComponent,
    TransitionGroupItemDirective,
  ]
})
export class CoreUIModule {
  static forRoot(): ModuleWithProviders<CoreUIModule> {
    return {
      ngModule: CoreUIModule
    };
  }
}
